module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-XBold Italic.c68a871d.woff";